module.exports = __webpack_public_path__ + "img/header_bg.31f63036.jpg";